import { useContext, createContext } from "react";
import { ISnackbarState } from "../types";
import { initialSnackbarState } from "./Actions";

export const SnackDataContext = createContext<ISnackbarState>(initialSnackbarState);
export const SnackDispatchContext = createContext<Function>(()=>0);

export function useSnackbarData() {
    const context = useContext(SnackDataContext);

    if (context===undefined) {
        throw new Error("useSnackbarData must be used inside SnackProvider");
    }

    return context;
}

export function useSnackbarDispatch() {
    const context = useContext(SnackDispatchContext);

    if (context===undefined) {
        throw Error("useSnackbarDispatch must be used inside snack provider")
    }

    return context;
}